// extracted by mini-css-extract-plugin
export var filterIncDec = "_aw-0";
export var leftBorder = "_aw-1";
export var rightBorder = "_aw-2";
export var stringInput = "_aw-3";